import { postAllUserLogout } from 'apis/auth';
import { axiosInstance } from 'apis/config/axios';
import { ROUTE_PATH } from 'constants/routePath';
import useAuth from 'hooks/useAuth';
import { useEffect } from 'react';
import { useMutation } from 'react-query';
import { useNavigate } from 'react-router-dom';
import styles from 'styles/pages/common/Forbidden.module.scss';
import ErrorIcon from 'assets/icons/error.png';

const Forbidden = () => {
  const navigate = useNavigate();
  const { setIsLogin } = useAuth();

  const { mutate: postAllUserLogoutMutation } = useMutation(postAllUserLogout, {
    onSuccess: () => {
      sessionStorage.clear();
      axiosInstance.defaults.headers.Authorization = '';
      setIsLogin({ isLogin: false });
    },
  });

  const onBtnClick = () => {
    postAllUserLogoutMutation();
  };

  useEffect(() => {
    if (!sessionStorage.getItem('accessToken')) {
      navigate(ROUTE_PATH.common.LOGIN);
    }
  }, [sessionStorage.getItem('accessToken')]);

  return (
    <div className={styles.wrapper}>
      <img src={ErrorIcon} alt="error" width={56} height={56} />
      <h1 className={styles.title}>403</h1>
      <p className={styles.text}>이 페이지에 대한 접근 권한이 없습니다.</p>
      <button className={styles.btn} onClick={onBtnClick}>
        로그인 페이지로 이동
      </button>
    </div>
  );
};

export default Forbidden;
